import { FaLinkedin, FaGithub } from "react-icons/fa";

const HeaderSocials = () => {
  return (
    <div className='home__socials'>
      <a href="https://www.linkedin.com/in/williamtran26/" className='home__social-link' target='_blank' rel="noreferrer">
        <FaLinkedin />
      </a>

      <a href="https://github.com/tpthanh2006" className='home__social-link' target='_blank' rel="noreferrer">
        <FaGithub />
      </a>
    </div>
  )
}

export default HeaderSocials